/**
 * Сегменты внутри «Сетки матчей»: `/steps/:stageId/grid/<tab>`.
 *
 * Существуют только у этапов типа `ROUND_ROBIN_1` / `ROUND_ROBIN_2`. У групповых
 * этапов и у плей-офф под-сегмента нет — конечный адрес там сам `/grid`.
 */
export enum StageGridTab {
  STANDING = 'standing',
  MATRIX = 'matrix',
}
